import { useMount } from 'ahooks';
import { Dropdown, Form, Input, message } from 'antd';
import { RevxButton } from 'components/RevxButton';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { RevxOverlay } from 'components/RevxOverlay';
import { RevxSpin } from 'components/RevxSpin';
import { AddInvoiceSharedParam } from 'domains/workspaceDomain';
import { JobItem } from 'domains/workspaceDomain';
import { TrimInput } from 'features/JobConfig/components/TrimInput';
import { ReactNode, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  EMAIL_MAXLENGTH,
  FIRST_NAME_MAXLENGTH,
  LAST_NAME_MAXLENGTH,
} from 'utils/constants';
import './ShareInvoiceDropdown.less';
import workspaceService from 'services/jobService';

interface FieldError {
  name: (string | number)[];
  errors: string[];
  warnings: string[];
}

type Props = {
  children: ReactNode;
  jobItem?: JobItem;
  onUpdate?: (sharedUser?: {
    firstName: string;
    lastName: string;
    email: string;
  }) => void;
};
export const ShareInvoiceDropdown = (props: Props) => {
  const { jobItem, onUpdate } = props;
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [addShareFormErrorList, setAddShareFormErrorList] =
    useState<FieldError[]>();
  const [visibleDrop, setVisibleDrop] = useState(false);
  const [revxSpinloading, setRevxSpinloading] = useState<boolean>(false);

  const checkForm = useCallback(async () => {
    try {
      await form.validateFields();
      setAddShareFormErrorList([]);
    } catch (e) {
      setAddShareFormErrorList(form.getFieldsError());
    }
  }, [form]);

  useMount(() => {
    form.setFieldsValue({
      serialNumbers:
        jobItem?.quantityItems?.map((item) => item.serialNumber) || [],
    });
  });

  const resetForm = useCallback(() => {
    setAddShareFormErrorList([]);
    form.resetFields(['firstName', 'lastName', 'email']);
  }, [form, setAddShareFormErrorList]);

  const onFinish = useCallback(
    async (values: AddInvoiceSharedParam) => {
      setRevxSpinloading(true);
      console.log('i will add now');
      console.log(jobItem);
      console.log(values);
      if (jobItem?.id) {
        try {
          await workspaceService.addInvoiceShare({
            ...values,
            jobId: jobItem?.id,
            invoiceFileUrl: jobItem?.sendInvoiceFileUrl,
            quickBooksInvoiceUrl: jobItem?.sendQuickBooksInvoiceFileUrl,
          });
          message.success(t('jobConfig.stepViewQuote.sendShareTip'));
          resetForm();
          setVisibleDrop(false);
          if (typeof onUpdate === 'function') {
            // 传递新添加的用户信息给回调函数
            onUpdate({
              firstName: values.firstName,
              lastName: values.lastName,
              email: values.email,
            });
          }
          setRevxSpinloading(false);
        } catch {
          setRevxSpinloading(false);
        }
      }
    },
    [jobItem, t, onUpdate, resetForm]
  );

  return (
    <Dropdown
      onVisibleChange={(e) => {
        resetForm();
        setVisibleDrop(e);
      }}
      trigger={['click']}
      placement="bottomCenter"
      visible={visibleDrop}
      align={{ offset: [15, -20] }}
      overlay={
        <RevxOverlay className="share-invoice-overlay">
          <RevxSpin spinning={revxSpinloading}>
            <Form
              form={form}
              onChange={checkForm}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={checkForm}
            >
              <RevxFlexLayout className="shared-content" align="top">
                <RevxFlexLayout
                  className={`ant-input shared-content-input ${
                    addShareFormErrorList &&
                    addShareFormErrorList?.filter(
                      (errorObj) =>
                        (errorObj.name.includes('firstName') ||
                          errorObj.name.includes('lastName')) &&
                        errorObj.errors.length
                    ).length > 0
                      ? 'shared-content-input-error'
                      : ''
                  }`}
                >
                  <Form.Item
                    name="firstName"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter First Name',
                      },
                    ]}
                  >
                    <TrimInput
                      maxLength={FIRST_NAME_MAXLENGTH}
                      style={{ marginRight: 12 }}
                      placeholder="First Name"
                    />
                  </Form.Item>
                  <Form.Item
                    name="lastName"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter Last Name',
                      },
                    ]}
                  >
                    <TrimInput
                      maxLength={LAST_NAME_MAXLENGTH}
                      placeholder="Last Name"
                    />
                  </Form.Item>
                </RevxFlexLayout>

                <Form.Item
                  name="email"
                  className="shared-content-email"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter Email',
                    },
                    {
                      type: 'email',
                      message: 'Please enter valid Email',
                    },
                  ]}
                >
                  <Input maxLength={EMAIL_MAXLENGTH} placeholder="Email" />
                </Form.Item>
              </RevxFlexLayout>
              <Form.Item
                style={{ textAlign: 'center', marginBottom: 0, marginTop: 16 }}
              >
                <RevxButton type="primary" htmlType="submit">
                  {t('common.send')}
                </RevxButton>
              </Form.Item>
            </Form>
          </RevxSpin>
        </RevxOverlay>
      }
    >
      <div
        onClick={() => {
          setVisibleDrop(true);
        }}
      >
        {props.children}
      </div>
    </Dropdown>
  );
};
